var delaynewfilter = ms => new Promise(res => setTimeout(res, ms));

class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.inputs = this.querySelectorAll("input[type='checkbox']")
    this.inputs.forEach(input => {
      input.addEventListener("click", async (e) => {
        if (e.target?.checked) {
          this.filterData.push({ "key": e.target?.name, "value": e.target?.value })
        }
        else {
          this.filterData = this.filterData.filter(function (item) {
            if (!(item.key == e.target.name && item.value == e.target.value)) {
              return item
            }
          })
        }
        this.get_collection_page()

      })
    })
  }


  get_collection_page() {
    var searchParams = ''
    this.filterData.forEach(filter => {
      searchParams = searchParams + `&${filter.key}=${encodeURIComponent(filter.value)}`
    })
    this.getSections().forEach(async section => {

      const url = `${window.location.pathname}?section_id=${section.section}${searchParams}`;
      this.handleLock()

      document.getElementById("CollectionProductGrid").classList.add('fade');
      document.getElementById("CollectionProductGrid").innerHTML = "<div class='loadersmall'></div>"
      await delaynewfilter(500);
      document.getElementById("CollectionProductGrid").classList.remove('fade');
      var res = await this.renderSectionFromFetch(url)
      var y = new DOMParser()
        .parseFromString(res, 'text/html')
      document.getElementById("CollectionProductGrid").classList.add('fade');
      await delaynewfilter(500);
      // console.log(y.getElementById("collectionTemplate"))
      // document.getElementById("collectionTemplate").innerHTML = y.getElementById("collectionTemplate").innerHTML
      y = y.getElementById("CollectionProductGrid")
      document.getElementById("CollectionProductGrid").innerHTML = y.innerHTML
      document.getElementById("CollectionProductGrid").classList.remove('fade');
      if (window.InspiredGoProductCardMacros?.refresh) {
        window.InspiredGoProductCardMacros.refresh();
      } else {
        document.dispatchEvent(new CustomEvent('inspiredgo:product-cards-rendered'));
      }
      set_collection_items()
      this.handleUnLock()
    })

  }
  handleLock() {
    this.inputs.forEach(input => {
      input.disabled = true
    })
  }
  handleUnLock() {
    this.inputs.forEach(input => {
      input.disabled = false
    })
  }

  renderSectionFromFetch(url) {
    return fetch(url)
      .then(response => response.text())
      .then((responseText) => responseText);
  }


  getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }
}

class CollectionFiltersSubscription extends HTMLElement {
  constructor() {
    super();

    this.filterData = [];
    this.inputs = this.querySelectorAll("input[type='checkbox']")
    console.log(this.inputs)

    if (this.inputs.length == 0) {
      this.renderSectionFromFetch('/collections/all').then(res => {

        var y = new DOMParser()
          .parseFromString(res, 'text/html')
        var template = y.querySelector("#collectionTemplate").content
        console.log(template)

        var x = (template.querySelector("collection-filters-subscription") || template.querySelector("collection-filters")).innerHTML;
        this.innerHTML = x;
        this.inputs = this.querySelectorAll("input[type='checkbox']")
        this.set_input_onclick_listener()

      });
    }
    else {
      this.set_input_onclick_listener()
    }
  }

  set_input_onclick_listener() {
    this.inputs.forEach(input => {
      input.addEventListener("click", async (e) => {
        if (e.target?.checked) {
          this.filterData.push({ "key": e.target?.name, "value": e.target?.value })
        }
        else {
          this.filterData = this.filterData.filter(function (item) {
            if (!(item.key == e.target.name && item.value == e.target.value)) {
              return item
            }
          })
        }
        this.get_collection_page()

      })
    })
  }

  get_collection_page() {
    var searchParams = ''
    this.filterData.forEach(filter => {
      searchParams = searchParams + `&${filter.key}=${encodeURIComponent(filter.value)}`
    })
    this.getSections().forEach(async section => {
      var parse_url = window.location.pathname;
      if (window.location.pathname.includes('account')) {
        parse_url = '/collections/all'
      }
      const url = `${parse_url}?${searchParams}`;
      this.handleLock()

      document.getElementById("CollectionProductGrid_NEw").classList.add('fade');
      document.getElementById("CollectionProductGrid_NEw").innerHTML = "<div class='loadersmall'></div>"
      await delaynewfilter(500);
      document.getElementById("CollectionProductGrid_NEw").classList.remove('fade');
      var res = await this.renderSectionFromFetch(url)
      var y = new DOMParser()
        .parseFromString(res, 'text/html')
      console.log(y)
      document.getElementById("CollectionProductGrid_NEw").classList.add('fade');
      await delaynewfilter(500);
      // console.log(y.getElementById("collectionTemplate"))
      // document.getElementById("collectionTemplate").innerHTML = y.getElementById("collectionTemplate").innerHTML
      y = y.getElementById("collectionTemplate").content.getElementById("CollectionProductGrid_NEw")
      document.getElementById("CollectionProductGrid_NEw").innerHTML = y.innerHTML
      document.getElementById("CollectionProductGrid_NEw").classList.remove('fade');
      if (window.InspiredGoProductCardMacros?.refresh) {
        window.InspiredGoProductCardMacros.refresh();
      } else {
        document.dispatchEvent(new CustomEvent('inspiredgo:product-cards-rendered'));
      }
      this.handleUnLock()
      var menu = document.querySelector("menu-wrapper");
      const templateProducts = Array.from(document.getElementById("product-grid").children).filter(child => child.className === 'grid__item');
      menu.productGrid = document.getElementById("product-grid")
      await document.querySelector("menu-wrapper").initialize(menu.subscriptionItemManager.subscription, menu.subscriptionItemManager, templateProducts, menu.templateDrawerItem)
    })

  }
  handleLock() {
    this.inputs.forEach(input => {
      input.disabled = true
    })
  }
  handleUnLock() {
    this.inputs.forEach(input => {
      input.disabled = false
    })
  }

  renderSectionFromFetch(url) {
    return fetch(url)
      .then(response => response.text())
      .then((responseText) => responseText);
  }


  getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }
}

class CollectionFiltersSubscriptionSideNav extends HTMLElement {
  constructor() {
    super();

    this.filterData = [];
    this.inputs = this.querySelectorAll("input[type='checkbox']")
    console.log(this.inputs)

    if (this.inputs.length == 0) {
      this.renderSectionFromFetch('/collections/all').then(res => {

        var y = new DOMParser()
          .parseFromString(res, 'text/html')
        var template = y.querySelector("#collectionTemplate").content
        console.log(template)

        var x = (template.querySelector("collection-filters-subscription") || template.querySelector("collection-filters"));
        var divs = x.querySelectorAll('.filter-block');
        for (var i = 0; i < divs.length; i++) {
          divs[i].classList.add('col-sm-6');
        }
        this.innerHTML = x.innerHTML;
        this.inputs = this.querySelectorAll("input[type='checkbox']")
        this.set_input_onclick_listener()

      });
    }
    else {
      this.set_input_onclick_listener()
    }
  }

  set_input_onclick_listener() {
    this.inputs.forEach(input => {
      input.addEventListener("click", async (e) => {
        if (e.target?.checked) {
          this.filterData.push({ "key": e.target?.name, "value": e.target?.value })
        }
        else {
          this.filterData = this.filterData.filter(function (item) {
            if (!(item.key == e.target.name && item.value == e.target.value)) {
              return item
            }
          })
        }
        this.get_collection_page()

      })
    })
  }

  get_collection_page() {
    var searchParams = ''
    this.filterData.forEach(filter => {
      searchParams = searchParams + `&${filter.key}=${encodeURIComponent(filter.value)}`
    })
    this.getSections().forEach(async section => {
      var parse_url = window.location.pathname;
      if (window.location.pathname.includes('account')) {
        parse_url = '/collections/all'
      }
      const url = `${parse_url}?${searchParams}`;
      this.handleLock()

      document.querySelector("menu-wrapper-subscription .collection #product-grid").classList.add('fade');
      document.querySelector("menu-wrapper-subscription .collection #product-grid").innerHTML = "<div class='loadersmall'></div>"
      await delaynewfilter(500);
      document.querySelector("menu-wrapper-subscription .collection #product-grid").classList.remove('fade');
      var res = await this.renderSectionFromFetch(url)
      var y = new DOMParser()
        .parseFromString(res, 'text/html')
      document.querySelector("menu-wrapper-subscription .collection #product-grid").classList.add('fade');
      await delaynewfilter(500);
      y = y.getElementById("collectionTemplate").content.querySelector("#CollectionProductGrid_NEw #product-grid")
      document.querySelector("menu-wrapper-subscription .collection #product-grid").innerHTML = y.innerHTML
      document.querySelector("menu-wrapper-subscription .collection #product-grid").classList.remove('fade');
      if (window.InspiredGoProductCardMacros?.refresh) {
        window.InspiredGoProductCardMacros.refresh();
      } else {
        document.dispatchEvent(new CustomEvent('inspiredgo:product-cards-rendered'));
      }
      this.handleUnLock()
      var menu = document.querySelector("menu-wrapper-subscription");
      const templateProducts = Array.from(document.querySelector("menu-wrapper-subscription .collection #product-grid").children).filter(child => child.className === 'grid__item');
      menu.productGrid = document.querySelector("menu-wrapper-subscription .collection #product-grid")
      await document.querySelector("menu-wrapper-subscription").initialize(menu.subscriptionItemManager.subscription, menu.subscriptionItemManager, templateProducts, menu.templateDrawerItem)
    })

  }
  handleLock() {
    this.inputs.forEach(input => {
      input.disabled = true
    })
  }
  handleUnLock() {
    this.inputs.forEach(input => {
      input.disabled = false
    })
  }

  renderSectionFromFetch(url) {
    return fetch(url)
      .then(response => response.text())
      .then((responseText) => responseText);
  }


  getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }
}


customElements.define('collection-filters-subscription', CollectionFiltersSubscription);
customElements.define('collection-filters-subscription-side-nav', CollectionFiltersSubscriptionSideNav);
customElements.define('collection-filters', CollectionFilters);
